export default {
    _prefix: "Evaluation",
    labels: {
        agentComments: "Agent Comments",
        expandToggle: "Expand Multiple Select Questions",
    },
    messages: {
        submitEvaluation: (data: { releaseDate: string }) => {
            return "Evaluation submitted with a release date of {{releaseDate}}";
        },
        noReleaseDate: "Evaluation submitted with no release date.",
        submitCalibration: "Evaluation submitted for a Calibration",
        evaluationScoringComplete: {
            title: "Evaluation Scoring Complete",
            body: "Evaluation automated scoring is ready for review",
        },
    },
};
